export default "__VITE_ASSET__BFBbYw7C__"